module.exports = __webpack_public_path__ + "static/media/twitterSentiment2.a70dfae9.jpg";